import Store from 'store/store'
import { Component } from 'utils/jsx'
import { writable, derived } from 'utils/state'
import classnames from 'classnames'

export default class TextEditable extends Component {
  beforeRender (props) {
    this.update = this.update.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handlePaste = this.handlePaste.bind(this)
    this.handleBlur = this.handleBlur.bind(this)

    this.state = {
      allowUpdate: true,
      untouched: writable(true),
      value: props['store-value'] || writable(props.placeholder || '')
    }

    this.state.length = derived(this.state.value, v => v.length)
    this.state.overflow = derived(this.state.length, len => props.maxLength && len > props.maxLength)
    this.state.invalid = derived([this.state.value, this.state.overflow], () => {
      const value = this.state.value.get()
      if (props.required && !value) return true
      if (this.state.overflow.get()) return true
      if (props.validate && !props.validate(value)) return true
    })
  }

  template (props) {
    return (
      <div
        class={classnames('text-editable', props.class, { 'is-required': props.required })}
        store-class-is-untouched={this.state.untouched}
        store-class-is-invalid={this.state.invalid}
        store-class-has-overflow={this.state.overflow}
      >
        <div
          ref={this.ref('value')}
          contentEditable
          class='text-editable__value'
          event-input={this.handleInput}
          event-paste={this.handlePaste}
          event-blur={this.handleBlur}
          event-keydown={this.handleKeyDown}
          placeholder={props.placeholder}
        >
          {this.state.value.get()}
        </div>
        <div
          ref={this.ref('counter')}
          class='text-editable__counter'
          store-text={this.state.length}
          data-max={props.maxLength}
        />
      </div>
    )
  }

  afterRender () {
    this.state.value.subscribe(this.update)
  }

  update () {
    if (!this.state.allowUpdate) return
    this.state.untouched.set(false)
    this.refs.value.innerText = this.state.value.get()
  }

  handlePaste (e) {
    e.preventDefault()
    const value = e.clipboardData.getData('text/plain')
    window.document.execCommand('insertText', false, value)
  }

  handleBlur (e) {
    this.state.untouched.set(false)
    this.state.value.set(this.state.value.current
      .replace(/[\r\n]+/g, '\n')
    )
  }

  handleKeyDown (e) {
    // Insert visual non-breaking space on alt+space. Theses characters will be
    // replaced by real spaces in paper/Paragraph once the line wrapping
    // algorithm is done
    if (e.altKey && e.code === 'Space') {
      e.preventDefault()
      document.execCommand('insertText', false, Store.constants.get().NBSP_SYMBOL)
    }
  }

  handleInput (e) {
    e.preventDefault()

    this.state.allowUpdate = false
    this.state.value.set(e.target.innerText)
    this.state.allowUpdate = true
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/TextEditable.js